'use strict';
var hasOwn = require('../internals/has-own-property');

module.exports = function (descriptor) {
  return descriptor !== undefined && (hasOwn(descriptor, 'value') || hasOwn(descriptor, 'writable'));
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/is-data-descriptor.js
// module id = 538
// module chunks = 0